import wx from "weixin-js-sdk";
import { getWechatConfig } from "../commJs/api";

export const isWechat = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
};

export const wechatShare = (title = "四川手机报") => {
  let url = window.location.href.split("#")[0].toString();
  const origin =
    (window.APP_CONFIG && window.APP_CONFIG.PUBLIC_ORIGIN) ||
    window.location.origin;
  const imgUrl = `${origin}/img/logo-500.jpg`;
  const shareDesc = "手机融媒体，直达千万屏";
  getWechatConfig({ url: url }).then((res) => {
    if (res.success == "true") {
      let resConfig = JSON.parse(res.data);
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: resConfig.appId, // 必填，公众号的唯一标识
        timestamp: resConfig.timestamp, // 必填，生成签名的时间戳
        nonceStr: resConfig.nonceStr, // 必填，生成签名的随机串--后端用小写  注意
        signature: resConfig.signature, // 必填，签名，见附录1
        jsApiList: [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "checkJsApi",
        ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function () {
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
        console.log("weixin 验证成功... ...");
        // 分享到朋友圈
        wx.checkJsApi({
          jsApiList: [
            "updateAppMessageShareData",
            "updateTimelineShareData",
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
          ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          success: function (res) {
            console.log(res);
            // 以键值对的形式返回，可用的api值true，不可用为false
            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
          },
        });
        wx.updateTimelineShareData({
          title: title, // 分享标题
          link: window.location.href || resConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          desc: shareDesc,
          imgUrl, // 分享图标
          success: function () {
            console.log("分享到朋友圈成功");
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });
        // 分享给朋友
        wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: shareDesc, // 分享描述
          link: window.location.href || resConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl, // 分享图标
          type: "", // 分享类型,music、video或link，不填默认为link
          success: function () {
            console.log("分享到朋友圈成功");
            // 用户确认分享后执行的回调函数
          },
          cancel: function () {
            // 用户取消分享后执行的回调函数
          },
        });
      });

      wx.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        console.log("weixin 验证失败");
        console.log(res);
      });
    }
  });
};
